module.exports = __webpack_public_path__ + "static/media/AzoSansRegular.a7eeafae.woff";